import { Component } from '@angular/core';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the RecuperarContraseñaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-recuperar-contrasena',
  templateUrl: 'recuperar-contraseña.html',
})
export class RecuperarContraseñaPage {
  public email;
  public validEmail: boolean = true;
  public emailSended: boolean = false;
  private regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RecuperarContraseñaPage');
  }

  SendEmail($event) {
    if (this.regexp.test(this.email)) {
      this.validEmail = true;
      //todo: Llamado a la api o servicio para enviar clave, 
      //todo: mostrar mensaje al usuario
      this.emailSended = true;
    } else {
      this.validEmail = false;
    }
  } 
  BackToLogin() {
    this.navCtrl.remove(1);
  }
}



// WEBPACK FOOTER //
// ./src/pages/recuperar-contraseña/recuperar-contraseña.ts